import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdminComponent } from './pages/layout/admin/admin.component';
import { AuthComponent } from './pages/layout/auth/auth.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './pages/shared/shared.module';
import { MenuItems } from './pages/shared/menu-items/menu-items';
import { BreadcrumbsComponent } from './pages/layout/admin/breadcrumbs/breadcrumbs.component';
import { CleanComponent } from './pages/layout/clean/clean.component';
import { RegisterMiddlewareComponent } from './pages/layout/register-middleware/register-middleware.component';
import { AuthGuard } from './guard/auth.guard.ts';
import { NgxsModule } from '@ngxs/store';
import { PersonState } from './state-manager/state/person-register.state';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { AuthState } from './state-manager/state/auth.state';
import { FingerprintState } from './state-manager/state/fingerprint.state';
import { PH3AService } from './services/PH3A.service';
import { DocumentTypeService } from './services/document-type.service';
import { RegistrationService } from './services/registration.service';
import { DomainService } from './services/domain.service';
import { ViaCepService } from './services/via-cep.service';
import { HelpTextService } from './services/help-text.service';
import { SuitabilityScoreState } from './state-manager/state/suitability-score.state';
import { CookieService } from 'ngx-cookie-service';
import { LoginService } from './services/login.service';
import { CompanyState } from './state-manager/state/company-register.state';
import { PersonService } from './services/person.service';
import { CompanyService } from './services/company.service';
import { SuitabilityScoreBehaviorService } from './state-manager/behavior-subjects/suitability-behavior.service';
import { MixpanelService } from './services/mix-panel.service';
import { LoginComponent } from './pages/login/login.component';
import { DateService } from './services/date.service';
import { DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Interceptor } from './services/httpUtils/interceptor.module';
import { InlineSVGModule } from 'ng-inline-svg';
import { RegisterState } from './state-manager/state/register.state';
import MsCotista from './services/graphql/msCotista';
import { VxMaestroService } from './services/vxmaestro.service';
import { MsCotistaService } from './services/mscotista.service';
import { MssignService } from './services/mssign.service';
import { FingerprintService } from './services/fingerprint.service';
import { GraphqlClient } from './services/graphql/graphqlClient';
import { GeolocationService } from './services/geolocation.service';
import { ToastyModule } from 'ng2-toasty';
import { NotificationState } from './state-manager/state/notification.state';

@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    AuthComponent,
    CleanComponent,
    BreadcrumbsComponent,
    LoginComponent,
    RegisterMiddlewareComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    Interceptor,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    NgxsModule.forRoot([
      PersonState,
      CompanyState,
      AuthState,
      RegisterState,
      SuitabilityScoreState,
      FingerprintState,
      NotificationState
    ]),
    NgxsReduxDevtoolsPluginModule.forRoot(),
    NgxsLoggerPluginModule,
    InlineSVGModule.forRoot(),
    ToastyModule.forRoot(),
    FormsModule
  ],
  providers: [
    HttpClientModule,
    DatePipe,
    MenuItems,
    AuthGuard,
    PH3AService,
    PersonService,
    CompanyService,
    SuitabilityScoreBehaviorService,
    DocumentTypeService,
    RegistrationService,
    FingerprintService,
    DomainService,
    CookieService,
    ViaCepService,
    HelpTextService,
    LoginService,
    MixpanelService,
    DateService,
    MsCotista,
    GraphqlClient,
    VxMaestroService,
    MsCotistaService,
    MssignService,
    GeolocationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
